import React from 'react';
import Menu, { MenuProps } from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { Divider } from '@mui/material';

type MenuItemProps = React.ComponentProps<typeof MenuItem>;
export type DropdownMenuItem = MenuItemProps & {
    hidden?: boolean,
    allow?: boolean,
    label: string,
}

export type DropdownMenuGroup = {
    hidden?: boolean,
    allow?: boolean,
    groupItems: DropdownMenuItem[],
}

export type DropdownMenuProps = MenuProps & {
    menuItems?: DropdownMenuItem[],
    menuGroups?: DropdownMenuGroup[],
}

export function DropdownMenu({
    menuItems,
    menuGroups = [],
    onClose,
    ...menuProps
}: DropdownMenuProps) {

    const visibleGroups = menuGroups?.length
        ? menuGroups.filter(g => !g.hidden && g.allow !== false && g.groupItems.some(i => !i.hidden && i.allow !== false))
        : [{ groupItems: menuItems ?? [] }];

    return (
        <Menu
            transformOrigin={{ horizontal: 'center', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
            onClose={onClose}

            {...menuProps}

            MenuListProps={{
                'aria-labelledby': 'basic-button',
                ...menuProps.MenuListProps,
            }}
            PaperProps={{
                sx: {
                    mt: .5,
                    textAlign: 'left',
                    minWidth: '120px',
                    ...menuProps?.PaperProps?.sx,
                },
                ...menuProps.PaperProps,
            }}
        >
            {visibleGroups.map((group, gIndex) => (
                <React.Fragment key={gIndex}>
                    {group.groupItems.filter(r => !r.hidden && r.allow !== false).map((itemProps) => (
                        <MenuItem
                            key={itemProps.key || itemProps.label}
                            {...itemProps}
                            onClick={(e) => {
                                itemProps.onClick && itemProps.onClick(e);
                                onClose && onClose(e, 'backdropClick');
                            }}
                        >
                            {itemProps.label || itemProps.children}
                        </MenuItem>
                    ))}
                    {gIndex < visibleGroups.length - 1 && <Divider />}
                </React.Fragment>
            ))}

        </Menu>
    );
}
